import { IconChevronDown } from 'featherico';
import { useState } from 'react';
import Button from '../../../../components/Button';
import Modal from '../../../../components/Modal';

type Props = {
    onDismiss: () => void;
};

export function NotifyMovedHint({ onDismiss }: Props) {
    const [isOpen, setIsOpen] = useState(false);

    const handleClose = () => {
        setIsOpen(false);
        onDismiss();
    };

    return (
        <>
            <Button kind="TRANSPARENT" isSmall onClick={() => setIsOpen(true)}>
                <span>Notify</span> <IconChevronDown />
            </Button>
            <Modal isOpen={isOpen} title="Moved to Admin Menu" size="SM_WIDTH" onClose={handleClose}>
                <p>
                    The Notifications menu has moved into the Admin menu, so we have more space available for our new
                    &quot;Views&quot; feature.
                </p>
            </Modal>
        </>
    );
}
